/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Cue_4Inputs */

const en_us2_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoulders back, chest open.`)
};

const pt_br2_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombros para trás, peito aberto.`)
};

const es_419_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hombros atrás, pecho abierto.`)
};

const pt_pt2_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ombros para trás, peito aberto.`)
};

const fr_fr2_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épaules en arrière, poitrine ouverte.`)
};

const de_de2_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schultern zurück, Brust raus.`)
};

const it_it2_workout_cue_4 = /** @type {(inputs: Workout_Cue_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalle indietro, petto aperto.`)
};

/**
* | output |
* | --- |
* | "Shoulders back, chest open." |
*
* @param {Workout_Cue_4Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_cue_4 = /** @type {((inputs?: Workout_Cue_4Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Cue_4Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_cue_4(inputs)
	if (locale === "es-419") return es_419_workout_cue_4(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_cue_4(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_cue_4(inputs)
	if (locale === "de-DE") return de_de2_workout_cue_4(inputs)
	if (locale === "it-IT") return it_it2_workout_cue_4(inputs)
	return en_us2_workout_cue_4(inputs)
});
export { workout_cue_4 as "workout.cue_4" }